<template>
  <div
    id="graphs-legend"
    :class="{
      'graphs-legend-container': !computedPosition,
      'graps-legend-container-fullscreen': computedPosition
    }"
  >
    <div v-for="(item, i) in items" :key="i" class="item">
      <div class="circle" :style="{ 'background-color': item.color }"></div>
      <span class="label">{{ item.title }}</span>
    </div>
  </div>
</template>
<script lang="ts" setup>
import Colors from '@/utils/colors'
import { useI18n } from 'vue-i18n'
import { watchEffect, ref } from 'vue'
import { useRealm } from '@/composables/useRealm'
const { t } = useI18n()
const { filtersMap } = useRealm()
const items: Array<{ title: string; color: string }> = [
  {
    title: t('general__text__used'),
    color: Colors.graph.blue
  },
  ...(filtersMap.ONLY_BOOKABLE
    ? [
        {
          title: t('general__text__booked'),
          color: Colors.graph.orange
        }
      ]
    : []),
  {
    title: t('general__text__not-used'),
    color: Colors.graph.gray
  }
]
const computedPosition = ref(false) // Start with initial value
const updateComputedPosition = () => {
  computedPosition.value = window.innerWidth <= 1024
}
updateComputedPosition()

// Watcher for window resize
watchEffect(() => {
  window.addEventListener('resize', updateComputedPosition)
})
</script>

<style scoped lang="scss">
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/font-mixins';
@use '@/styles/variables.scss' as old-variables;

#graphs-legend {
  @include font-mixins.desktop-regular-label;
  height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: variables.$color-pure-white;
  color: variables.$color-greyscale-content;
  width: 100%;
  left: 0;
  gap: 16px;
  border-top: 1px solid variables.$color-greyscale-line-grey;
}
#graphs-legend.graphs-legend-container {
  position: absolute;
  bottom: 0;
}
#graphs-legend.graps-legend-container-fullscreen {
  bottom: 0;
  position: fixed;
}
.circle {
  width: 16px;
  height: 16px;
  border-radius: 8px;
}

.label {
  font-size: 12px;
  color: old-variables.$color-text-grey;
  white-space: nowrap;
}
.item {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
</style>
